import "../index.js";
import type {NexusResult, OttoNexus} from "@otto-ec/global-resources/nexus";
import {apps} from "../index.js";
import type { AppType } from "./appInfo.js";
export { AppType } from "./appInfo.js";
import type { GatedFeature } from "../appVersionRequirements.js";
export { APP_VERSION_REQUIREMENTS, GatedFeatures } from "../appVersionRequirements.js";
export type { AppVersionRequirement, GatedFeature } from "../appVersionRequirements.js";

export type NativeAppEvent = {
    /**
 *
 */
    name: string;
    /**
 *
 */
    timestamp: Date;
}

export type GlobalRaw = {
    /**
 *
 */
    retrieveNativeAppEvents(): NexusResult<Promise<NativeAppEvent[]>>;

    /**
 *
 */
    runningInApp(): NexusResult<boolean>;

    /**
 *
 */
    appType(): NexusResult<AppType | undefined>;

    /**
 *
 */
    appVersion(): NexusResult<Promise<string | undefined>>;

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    supportsFeature(feature: GatedFeature): NexusResult<Promise<boolean>>;

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    supportedAppVersion(minAppVersions: {
        android: string | null;
        ios: string | null;
    }): NexusResult<Promise<boolean>>;
}

export type AppsGlobal = OttoNexus["apps"]["global"]

/**
 *
 */
export const global: AppsGlobal = apps.global;

/**
 *
 */
export const retrieveNativeAppEvents: AppsGlobal["retrieveNativeAppEvents"] = global.retrieveNativeAppEvents;

/**
 *
 */
export const runningInApp: AppsGlobal["runningInApp"] = global.runningInApp;

/**
 *
 */
export const appType: AppsGlobal["appType"] = global.appType;

/**
 *
 */
export const appVersion: AppsGlobal["appVersion"] = global.appVersion;

/**
 *
 */
export const supportsFeature: AppsGlobal["supportsFeature"] = global.supportsFeature;

/**
 *
 */
export const supportedAppVersion: AppsGlobal["supportedAppVersion"] = global.supportedAppVersion;
